// extracted by mini-css-extract-plugin
export default {"wrapper":"CatalogSearch_wrapper__cVX2p","icon":"CatalogSearch_icon__7Aqfy","input":"CatalogSearch_input__DS94m"};